
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.576"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "bn": "static-7.576",
    "cs": "static-7.576",
    "da": "static-7.576",
    "de": "static-7.576",
    "el": "static-7.576",
    "en": "static-7.576",
    "es-mx": "static-7.576",
    "es": "static-7.576",
    "fi": "static-7.576",
    "fr": "static-7.576",
    "hr": "static-7.576",
    "hu": "static-7.576",
    "id": "static-7.576",
    "it": "static-7.576",
    "ja": "static-7.576",
    "ko": "static-7.576",
    "nl": "static-7.576",
    "no": "static-7.576",
    "pl": "static-7.576",
    "pt-br": "static-7.576",
    "ro": "static-7.576",
    "ru": "static-7.576",
    "sv": "static-7.576",
    "th": "static-7.576",
    "vi": "static-7.576",
    "zh-cn": "static-7.576",
    "zh-hk": "static-7.576"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.576'}); }
})();


